import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 12.516c2.608 0 4.73-2.12 4.73-4.725A4.733 4.733 0 0 0 12 3.066a4.733 4.733 0 0 0-4.73 4.725A4.733 4.733 0 0 0 12 12.516M12 14.496c-3.045 0-7.095.333-7.095 3.21 0 3.227 5.34 3.227 7.095 3.227 3.045 0 7.094-.333 7.094-3.209 0-3.228-5.339-3.228-7.094-3.228"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserFilled);
export default ForwardRef;
